// import React, { useEffect, useState } from 'react';
// import { Link, useHistory } from 'react-router-dom';
// import axios from 'axios';
// import { Constants } from '../../endPoints'; // ✅ Import API Constants
// import { jwtDecode } from 'jwt-decode';

// export default function DashboardNav() {
//     const history = useHistory();
//     const [unreadCount, setUnreadCount] = useState(0);

//     const handleLogout = () => {
//         // Clear authentication tokens from local storage
//         localStorage.removeItem('accessToken');
//         localStorage.removeItem('refreshToken');

//         // Redirect to login page
//         history.push('/login');
//     };


//     useEffect(() => {
//         fetchUnreadMessages();
//         const interval = setInterval(fetchUnreadMessages, 60000); // Every 60 seconds refresh

//         return () => clearInterval(interval); // Clear interval on unmount
//     }, []);

//     const fetchUnreadMessages = async () => {
//         try {
//             const token = localStorage.getItem('authToken');
//             if (!token) return;
//             const decoded = jwtDecode(token);

//             const response = await axios.post(`${Constants.getChatListForProductOwner}`, { user_id: decoded.id });

//             if (response.data.status === 1) {
//                 const unreadChats = response.data.list.filter(chat => chat.unread_count > 0);  // ✅ list instead of data
//                 const totalUnread = unreadChats.reduce((sum, chat) => sum + chat.unread_count, 0);
//                 setUnreadCount(totalUnread);
//             }
//         } catch (error) {
//             console.error('Error fetching unread messages:', error);
//         }
//     };


//     return (
//         <div className='bg-[#fbf8f1] sidemenudash border-2 border-[#b3902d] rounded-lg overflow-hidden py-2'>
//             <Link to="/dashboard" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
//                 <div className='flex gap-3 items-center'>
//                     <i className="fa-solid fa-home text-[#b3902d]"></i> Dashboard
//                 </div>
//             </Link>
//             <Link to="/profile" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
//                 <div className='flex gap-3 items-center'>
//                     <i className="fa-regular fa-user text-[#b3902d]"></i> Profile
//                 </div>
//             </Link>
//             <Link to="/list-wishlist" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
//                 <div className='flex gap-3 items-center'>
//                     <i className="fa-regular fa-heart text-[#b3902d]"></i> Saved
//                 </div>
//             </Link>
//             <Link to="/sell-product" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
//                 <div className='flex gap-3 items-center'>
//                     <i className="fa-solid fa-tag text-[#b3902d]"></i> Sell Product
//                 </div>
//             </Link>
//             <Link to="/list-product" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
//                 <div className='flex gap-3 items-center'>
//                     <i className="fa-solid fa-list text-[#b3902d]"></i> Listing
//                 </div>
//             </Link>
//             <Link to="/inbox" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all relative">
//                 <div className='flex gap-3 items-center'>
//                     <i className="fa-regular fa-envelope text-[#b3902d]"></i> Chat Inbox {unreadCount > 0 && (
//                         <span className="ml-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
//                             {unreadCount}
//                         </span>
//                     )}
//                 </div>
//             </Link>
//             {/* <Link to="" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
//             <div className='flex gap-3 items-center'>
//                 <i class="fa-regular fa-bell text-[#b3902d]"></i> Notifications
//             </div>
//         </Link> */}
//             <Link to="/changed-password" className="block py-3 px-6 border-b border-[#e6e0d3] hover:bg-[#fff] transition-all">
//                 <div className='flex gap-3 items-center'>
//                     <i className="fa-solid fa-key text-[#b3902d]"></i> Change Password
//                 </div>
//             </Link>
//             {/* <Link to="" onClick={handleLogout} className="block py-3 px-6 hover:bg-[#fff] transition-all">
//                 <div className='flex gap-3 items-center'>
//                     <i class="fa-solid fa-power-off text-[#b3902d]"></i> Logout
//                 </div>
//             </Link> */}
//         </div>
//     )
// }


import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { Constants } from "../../endPoints";
import { jwtDecode } from "jwt-decode";

export default function DashboardNav() {
  const history = useHistory();

  const [unreadCount, setUnreadCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    history.push("/");
  };

  useEffect(() => {
    fetchUnreadMessages();
    const interval = setInterval(fetchUnreadMessages, 60000);
    return () => clearInterval(interval);
  }, []);

  const fetchUnreadMessages = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const decoded = jwtDecode(token);

      const response = await axios.post(
        `${Constants.getChatListForProductOwner}`,
        { user_id: decoded.id }
      );

      if (response.data.status === 1) {
        const unreadChats = response.data.list.filter(
          (chat) => chat.unread_count > 0
        );

        const totalUnread = unreadChats.reduce(
          (sum, chat) => sum + chat.unread_count,
          0
        );

        setUnreadCount(totalUnread);
      }
    } catch (error) {
      console.error("Error fetching unread messages:", error);
    }
  };

  return (
    <div className="dashboardNavWrapper">

      {/* Top Bar */}
      <div className="mobileTopBar">
        <button
          className="hamburgerBtn"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className="fa-solid fa-bars"></i> MENU
        </button>
      </div>

      {/* Navigation */}
      <div className={`dashboardMenu ${menuOpen ? "open" : ""}`}>

        <Link to="/dashboard" className="menuItem">
          <i className="fa-solid fa-home"></i> Dashboard
        </Link>

        <Link to="/profile" className="menuItem">
          <i className="fa-regular fa-user"></i> Profile
        </Link>

        <Link to="/list-wishlist" className="menuItem">
          <i className="fa-regular fa-heart"></i> Saved
        </Link>

        <Link to="/sell-product" className="menuItem">
          <i className="fa-solid fa-tag"></i> Sell Product
        </Link>

        <Link to="/list-product" className="menuItem">
          <i className="fa-solid fa-list"></i> Listing
        </Link>

        <Link to="/inbox" className="menuItem chatMenu">
          <i className="fa-regular fa-envelope"></i> Chat Inbox

          {unreadCount > 0 && (
            <span className="chatBadge">{unreadCount}</span>
          )}
        </Link>

        <Link to="/changed-password" className="menuItem">
          <i className="fa-solid fa-key"></i> Change Password
        </Link>

        {/* <div className="menuItem logoutBtn" onClick={handleLogout}>
          <i className="fa-solid fa-power-off"></i> Logout
        </div> */}

      </div>
    </div>
  );
}